import { BLOG_POSTS } from "./posts.generated";

const byDateDesc = (a, b) => (a.date < b.date ? 1 : a.date > b.date ? -1 : 0);

export { BLOG_POSTS };

export const getPostBySlug = (slug) => BLOG_POSTS.find((post) => post.slug === slug);

export const getFeaturedPosts = (limit = 4) =>
  BLOG_POSTS.filter((post) => post.featured).sort(byDateDesc).slice(0, limit);

export const getRelatedPosts = (slug, limit = 3) => {
  const current = getPostBySlug(slug);
  const others = BLOG_POSTS.filter((post) => post.slug !== slug);
  if (!current) return others.sort(byDateDesc).slice(0, limit);

  const scored = others.map((post) => ({
    post,
    score: (post.tags || []).filter((tag) => (current.tags || []).includes(tag)).length,
  }));
  scored.sort((a, b) => b.score - a.score || byDateDesc(a.post, b.post));
  return scored.map((item) => item.post).slice(0, limit);
};
